import { render } from "./RecentInventory.vue?vue&type=template&id=10f2b997"
import script from "./RecentInventory.vue?vue&type=script&lang=js"
export * from "./RecentInventory.vue?vue&type=script&lang=js"
script.render = render

export default script